//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cfr from './cfrList'
export default {
  components: {
    cfr,
  },
  name: 'maternal_form_c',
  data() {
    return {
      list_id: '',
      showCfrList: false,
      showSignature: false,
      cfrText: '',
      form: {
        room_number: '',
        maternal_name: '',
        childbirth_way: '',
        day_time: '',
        ponal_days_num: '',
        coly_temperature: '',
        coly_pulse: '',
        coly_weight: '',
        resys_gdg: '',
        resys_in_codin: '1',
        resys_e_num: '1',
        resys_e_color: '1',
        resys_e_sniff: '2',
        bre_mike_num: '2',
        bre_dis_pain: '1',
        bre_rup_nipple: '1',
        guid_opons: '',
        autograph: '',
        shifts: '',
        check_id: '',
      },
      option: {
        penColor: 'rgb(0, 0, 0)',
      },
      nurser_name: [],
      get_host: host.host,
      child_birth: '',
    }
  },
  methods: {
    GetNumberOfDays(date1, date2) {
      //获得天数
      //date1：开始日期，date2结束日期
      var a1 = Date.parse(new Date(date1))
      var a2 = Date.parse(new Date(date2))
      var day = parseInt((a2 - a1) / (1000 * 60 * 60 * 24)) //核心：时间戳相减，然后除以天数
      return day
    },
    change_date(value) {
      console.log(this.child_birth)
      this.apiMemberInfo(value)
    },
    //获取查房人列表
    apiGetCfrList() {
      let params = {
        token: this.$cookie.get('token'),
        store_id: this.$cookie.get('store_id'),
      }
      Api.checkRoomApi.getCheckInfo(params).then((res) => {
        console.info('获取查房人列表', res)
        if (res.errcode == 1) {
          this.nurser_name = res.data.nurser_name //过滤了离院，
          this.apiDetail()
        } else {
          this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo,
          })
        }
      })
    },
    //点击选择查房人
    selectPeople() {
      this.showCfrList = true
    },
    //赋值查房人ID
    cfrListEven(val, item) {
      this.showCfrList = val
      console.info(item)
      if (item) {
        this.form.check_id = item.id
        this.cfrText = item.user_name
      }
    },
    //时间戳转日期格式
    formatDateTime(inputTime) {
      var date = new Date(parseInt(inputTime) * 1000)
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      var d = date.getDate()
      d = d < 10 ? '0' + d : d
      var h = date.getHours()
      h = h < 10 ? '0' + h : h
      var minute = date.getMinutes()
      var second = date.getSeconds()
      minute = minute < 10 ? '0' + minute : minute
      second = second < 10 ? '0' + second : second
      return y + '-' + m + '-' + d
    },
    //请求用户基本信息
    apiMemberInfo(value) {
      let params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id,
      }
      Api.checkRoomApi.memberInfo(params).then((res) => {
        console.info(res)
        if (res.errcode == 1) {
          this.form.childbirth_way =
            res.data.birth_type == '1'
              ? '经阴道'
              : res.data.birth_type == '2'
              ? '剖宫产'
              : res.data.birth_type == '3'
              ? '小产'
              : ''
          this.form.maternal_name = res.data.name
          this.form.room_number = res.data.room_name
          this.child_birth = this.formatDateTime(res.data.child_birth)
          if (value) {
            let day = this.GetNumberOfDays(this.child_birth, value) + 1
            this.form.ponal_days_num = day
          }
        } else {
          this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo,
          })
        }
      })
    },
    // 保存
    save() {
      let signature = 'signature1'
      const sigRef = this.$refs[signature]
      const comp = Array.isArray(sigRef) ? sigRef[sigRef.length - 1] : sigRef
      if (!comp || !comp.save) return
      let png = comp.save()
      this.form.autograph = encodeURI(png)
      this.showSignature = true
    },
    //编辑
    edit() {
      this.showSignature = false
      this.form.autograph = ''
    },
    //清除
    clear() {
      let signature = 'signature1'
      const sigRef = this.$refs[signature]
      if (Array.isArray(sigRef)) {
        sigRef.forEach(c => c && c.clear && c.clear())
      } else if (sigRef && sigRef.clear) {
        sigRef.clear()
      }
      this.form.autograph = ''
    },
    //请求详情数据
    apiDetail() {
      let params = {
        token: this.$cookie.get('token'),
        id: this.$route.query.list_id,
      }
      this.$vux.loading.show({
        text: '正在加载',
      })
      Api.bbFormApi.getMaterRehNursEvalFind(params).then((res) => {
        console.info(res)
        if (res.errcode == 200) {
          let data = res.data
          this.form.room_number = data.room_number
          this.form.maternal_name = data.maternal_name
          this.form.childbirth_way = data.childbirth_way
          this.form.day_time = data.day_time
          this.form.ponal_days_num = data.ponal_days_num
          this.form.coly_temperature = data.coly_temperature
          this.form.coly_pulse = data.coly_pulse
          this.form.coly_weight = data.coly_weight
          this.form.resys_gdg = data.resys_gdg
          this.form.resys_in_codin = data.resys_in_codin
          this.form.resys_e_num = data.resys_e_num
          this.form.resys_e_color = data.resys_e_color
          this.form.resys_e_sniff = data.resys_e_sniff
          this.form.bre_mike_num = data.bre_mike_num
          this.form.bre_dis_pain = data.bre_dis_pain
          this.form.bre_rup_nipple = data.bre_rup_nipple
          this.form.guid_opons = data.guid_opons
          this.form.autograph =
            data.autograph.indexOf(this.get_host) != -1
              ? data.autograph
              : this.get_host + data.autograph
          this.form.shifts = data.shifts
          this.form.check_id = data.check_id
          this.showSignature = true
          this.$vux.loading.hide()
          if (this.nurser_name.length) {
            for (let item of this.nurser_name) {
              if (item.id == data.check_id) {
                this.cfrText = item.user_name
              }
            }
          }
        } else {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo,
          })
        }
      })
    },
    //请求添加数据
    apiAddForm() {
      let params = {
        token: this.$cookie.get('token'),
        number_id: this.$cookie.get('id'),
        maternal_info_id: this.$route.query.id,
        store_id: this.$cookie.get('store_id'),
        room_number: this.form.room_number,
        maternal_name: this.form.maternal_name,
        childbirth_way: this.form.childbirth_way,
        day_time: this.form.day_time,
        ponal_days_num: this.form.ponal_days_num,
        coly_temperature: this.form.coly_temperature,
        coly_pulse: this.form.coly_pulse,
        coly_weight: this.form.coly_weight,
        resys_gdg: this.form.resys_gdg,
        resys_in_codin: this.form.resys_in_codin,
        resys_e_num: this.form.resys_e_num,
        resys_e_color: this.form.resys_e_color,
        resys_e_sniff: this.form.resys_e_sniff,
        bre_mike_num: this.form.bre_mike_num,
        bre_dis_pain: this.form.bre_dis_pain,
        bre_rup_nipple: this.form.bre_rup_nipple,
        guid_opons: this.form.guid_opons,
        autograph: this.form.autograph,
        shifts: this.form.shifts,
        check_id: this.form.check_id,
      }
      console.info(params)
      this.$vux.loading.show({
        text: '正在加载',
      })
      Api.bbFormApi.addMaterRehNursEvalData(params).then((res) => {
        console.info(res)
        if (res.errcode == 200) {
          this.$vux.loading.hide()
          this.$router.replace({
            path: '/success',
            query: {
              id: this.$route.query.id,
              form_id: this.$route.query.form_id,
              tabVal: this.$route.query.tabVal,
              name: 'maternal_form_c',
            },
          })
        } else {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo,
          })
        }
      })
    },
    // 请求更新数据
    apiUpdateForm() {
      let params = {
        token: this.$cookie.get('token'),
        id: this.$route.query.list_id,
        number_id: this.$cookie.get('id'),
        maternal_info_id: this.$route.query.id,
        store_id: this.$cookie.get('store_id'),
        room_number: this.form.room_number,
        maternal_name: this.form.maternal_name,
        childbirth_way: this.form.childbirth_way,
        day_time: this.form.day_time,
        ponal_days_num: this.form.ponal_days_num,
        coly_temperature: this.form.coly_temperature,
        coly_pulse: this.form.coly_pulse,
        coly_weight: this.form.coly_weight,
        resys_gdg: this.form.resys_gdg,
        resys_in_codin: this.form.resys_in_codin,
        resys_e_num: this.form.resys_e_num,
        resys_e_color: this.form.resys_e_color,
        resys_e_sniff: this.form.resys_e_sniff,
        bre_mike_num: this.form.bre_mike_num,
        bre_dis_pain: this.form.bre_dis_pain,
        bre_rup_nipple: this.form.bre_rup_nipple,
        guid_opons: this.form.guid_opons,
        autograph:
          this.form.autograph.indexOf(this.get_host) != -1
            ? this.form.autograph.replace(this.get_host, '')
            : this.form.autograph,
        shifts: this.form.shifts,
        check_id: this.form.check_id,
      }
      console.info(params)
      this.$vux.loading.show({
        text: '正在加载',
      })
      Api.bbFormApi.updateMaterRehNursEvalData(params).then((res) => {
        console.info(res)
        if (res.errcode == 200) {
          this.$vux.loading.hide()
          this.$router.replace({
            path: '/success',
            query: {
              id: this.$route.query.id,
              form_id: this.$route.query.form_id,
              tabVal: this.$route.query.tabVal,
              name: 'maternal_form_c',
            },
          })
        } else {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo,
          })
        }
      })
    },
    submitForm() {
      let form = this.form
      console.log(form)
      if (
        form.room_number == '' ||
        form.maternal_name == '' ||
        form.check_id == '' ||
        form.shifts == '' ||
        form.childbirth_way == '' ||
        form.day_time == '' ||
        form.ponal_days_num == '' ||
        form.coly_temperature == '' ||
        form.coly_pulse == '' ||
        form.coly_weight == '' ||
        form.resys_gdg == '' ||
        form.resys_in_codin == '' ||
        form.resys_e_num == '' ||
        form.resys_e_color == '' ||
        form.resys_e_sniff == '' ||
        form.bre_mike_num == '' ||
        form.bre_dis_pain == '' ||
        form.bre_rup_nipple == '' ||
        form.guid_opons == '' ||
        form.autograph == ''
      ) {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请完善所有表单',
        })
        return
      }
      if (this.$route.query.list_id) {
        console.info('请求更新数据')
        this.apiUpdateForm()
      } else {
        console.info('请求添加数据')
        this.apiAddForm()
      }
    },
  },
  created() {
    this.apiMemberInfo()
    if (this.$route.query.list_id) {
      this.apiGetCfrList()
      this.list_id = this.$route.query.list_id
    } else {
      this.list_id = ''
      this.form.guid_opons = '母乳喂养、母婴同室'
    }
  },
}



// WEBPACK FOOTER //
// ./src/components/maternal_form_c.vue